<div class="under-construction">
   <div class="width-limited"><h1>Ce module est en cours de construction !</h1></div> 
    <p>Merci de votre patience</p>
    <div><img src="./assets/images/under-construction.png" alt="en construction" aria-hidden="true"/></div>
</div>